import register from '@/components/features/cms/blocks/StaticProductSlider/register';
import { StaticProductSlider } from './StaticProductSlider';

register(StaticProductSlider);
